import { render, staticRenderFns } from "./PolicyPage.vue?vue&type=template&id=c9cc958a&"
import script from "./PolicyPage.vue?vue&type=script&lang=js&"
export * from "./PolicyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports